import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import { UserRoles } from '@/constants';

const SECTION_TARGETS: Record<string, string> = {
  personal_details: '/portal/details',
  offerings: '/portal/specialty',
  // The old Speciality & Sub-speciality tab's value, already once redirected
  // to `offerings` by doctor-settings.tsx (2026-08-15) — still worth mapping
  // directly, since a link sent before that first redirect existed points
  // here, not at `offerings`.
  speciality_sub_speciality: '/portal/specialty',
  clinic_details: '/portal/clinic',
  // Billing absorbed into Subscription (2026-08-20 feedback, 2nd round).
  billing: '/portal/subscription',
  security: '/portal/security',
};

/**
 * Every /settings and /settings?section=... URL, redirected to its
 * /portal/* successor (issue #307). Bare /settings falls back to each
 * persona's default section — personal_details for a doctor, clinic_details
 * for either admin persona, matching today's DoctorSettings/AdminSettings
 * default `selectedSection`.
 */
export function SettingsRedirect() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const isAdmin = user?.role === UserRoles.Admin;

  const section = searchParams.get('section');
  const target = (section && SECTION_TARGETS[section]) || (isAdmin ? '/portal/clinic' : '/portal/details');

  return <Navigate to={target} replace />;
}
